/*
 * This is a code-based template
 * Renders symbology styles as HTML via approximatating the intent of the style
 */

import _ = require("underscore");
import Portal = require("portal-gis");
import $ = require("jquery");

const sqrt2 = Math.sqrt(2);

function as(v) {
    return "" + v + "px";
};

function asRgba(color: string | Array<number>) {
    if (typeof color === "string") return color;
    let c = { r: color[0], g: color[1], b: color[2], a: color[3] };
    if (typeof c.a === "undefined") c.a = 1;
    return `rgba(${c.r},${c.g},${c.b},${c.a})`;
}

function asImageData(symbol: {
    contentType?: string;
    imageData?: string;
}) {
    var url = `data:${symbol.contentType};base64,${symbol.imageData}`;
    return `url(${url})`;
}


class SymbologyTemplate {

    private setImage(div: JQuery, style: any) {
        // TODO: handle "url" and "imageData"
        style.fill && this.setFill(div, style.fill);
        style.outline && this.setOutline(div, style.outline);
    }

    //{"type":"circle","radius":12,"fill":{"color":[0,0,128]}}
    private setCircle(div: JQuery, style: Rhythm.Symbology.SimpleMarkerSymbol) {
        _.defaults(style, {
            radius: 10
        });

        style.fill && this.setFill(div, style.fill);

        $(div).css({
            width: (2 * style.radius),
            height: (2 * style.radius),
            borderRadius: style.radius
        });
    }

    private setFill(div: JQuery, symbol: Rhythm.Symbology.FillSymbol) {
        _.defaults(symbol, {
            style: "solid",
            color: "white"
        });

        let color = asRgba(symbol.color);

        switch (symbol.style) {
            case "solid":
                div.css("backgroundColor", color);
                break;
            default:
                console.warn(`unsupported style: ${symbol.style}`);
                div.css("backgroundColor", color);
                break;
        }
        symbol.outline && this.setOutline(div, symbol.outline);
    }

    private setLine(div: JQuery, symbol: Rhythm.Symbology.LineSymbol) {
        _.defaults(symbol, {
            style: "solid",
            color: "white",
            width: 1.0
        });

        let color = asRgba(symbol.color);

        switch (symbol.style) {
            case "solid":
                break;
            default:
                console.warn(`unsupported style: ${symbol.style}`);
                break;
        }

        div.css({
            "borderTopRightRadius": as(1.5 * symbol.width),
            "borderTopStyle": symbol.style,
            "borderRightStyle": symbol.style,
            "borderTopColor": color,
            "borderRightColor": color,
            "borderTopWidth": as(symbol.width),
            "borderRightWidth": as(symbol.width)
        });
    }

    private setOutline(div: JQuery, symbol: Rhythm.Symbology.LineSymbol) {
        _.defaults(symbol, {
            style: "solid",
            color: "black",
            width: 1.0
        });

        let color = asRgba(symbol.color);

        switch (symbol.style) {
            case "solid":
                break;
            default:
                console.warn(`unsupported style: ${symbol.style}`);
                break;
        }
        div.css("borderColor", color);
        div.css("borderWidth", symbol.width);
        div.css("borderStyle", symbol.style);
    }

    private setMarker(div: JQuery, symbol: Rhythm.Symbology.SimpleMarkerSymbol) {

        div.css({
            width: as(symbol.size),
            height: as(symbol.size),
            backgroundColor: asRgba(symbol.color)
        });
        symbol.outline && this.setOutline(div, symbol.outline);

        switch (symbol.style) {
            case "diamond":
                div.css({
                    width: as(symbol.size / sqrt2),
                    height: as(symbol.size / sqrt2)
                });
                // adjust to compensate for outline
                if (symbol.outline) {
                    let width = sqrt2 * symbol.outline.width;
                    let sx = width * 2;
                    div.css({
                        width: as(symbol.size - sx),
                        height: as(symbol.size - sx),
                        borderWidth: as(width),
                        marginTop: as(symbol.yoffset || 0),
                        marginLeft: as(symbol.xoffset || 0),
                    });
                }
                break;
            case "circle":
                break;
            case "cross":
            case "x":
                // trial and ERROR -- here we go!
                div.css({
                    backgroundColor: asRgba(symbol.color),
                    width: as(0.2 * symbol.size),
                    height: as(symbol.size),
                    border: "none",
                    marginLeft: as(0.4 * symbol.size)
                });
                {
                    let $helper = $("<div>");
                    $helper.css({
                        backgroundColor: asRgba(symbol.color),
                        position: "absolute",
                        top: as(0.4 * symbol.size),
                        left: as(-0.4 * symbol.size),
                        width: as(symbol.size),
                        height: as(0.2 * symbol.size)
                    });

                    div.append($helper);
                }
                break;
            default:
                console.warn(`unsupported style: ${symbol.style}`);
                break;
        }
    }

    private setPicture(div: JQuery, symbol: Rhythm.Symbology.PictureSymbol) {
        div.css({
            width: symbol.width + "pt",
            height: symbol.height + "pt",
            backgroundImage: asImageData(symbol),
            backgroundPositionX: symbol.xoffset || 0,
            backgroundPositionY: symbol.yoffset || 0,
            backgroundRepeat: "no-repeat"
        });
    }

    // {"type":"sfs","style":"solid","color":[246,197,103,0.5],"outline":{"type":"sls","style":"solid","color":[246,103,197,255],"width":0.4}}

    private renderIcons(item: Portal.MonikerSymbologyElement) {
        return item.Icons.map(icon => {
            let div = $(`<div>`);

            switch (icon.type) {
                case "style":
                    console.log("decoding style: ", icon.style);
                    let style = _.defaults(JSON.parse(icon.style), { type: "sls" });

                    div.addClass(`symbol symbol-${item.id} symbol-type-${style.type} symbol-style-${style.style}`);

                    switch (style.type) {
                        case "sfs":
                            this.setFill(div, style);
                            break;
                        case "sls":
                            this.setLine(div, style);
                            break;
                        case "sms":
                            this.setMarker(div, style);
                            break;
                        case "pms":
                        case "pfs":
                            this.setPicture(div, style);
                            break;
                        case "circle":
                            this.setCircle(div, style);
                            break;
                        case "mixed":
                            style.fill && this.setFill(div, style.fill);
                            style.image && this.setImage(div, style.image);
                            style.stroke && this.setLine(div, style.stroke);
                            break;
                        default:
                            console.warn(`unsupported type: ${style.type}`);
                            break;
                    }

                    break;

                case "icon":
                default:
                    let src = icon.style || requirejs.toUrl(`app/icons/${icon.id}`);
                    if (!src) {
                        console.warn("unable to determine icon");
                    }
                    if (0 > src.indexOf("//")) {
                        src = requirejs.toUrl(src);
                    }
                    div.addClass(`symbol symbol-${item.id} symbol-type-icon symbol-style-icon`);

                    div.css({
                        background: `url(${src}) no-repeat center`
                    });
                    break;
            }

            div.attr("title", icon.style);

            return div;
        });
    }

    renderItem(item: Portal.MonikerSymbologyElement) {
        let $rule = $("<div>").addClass("symbology-rule");
        {
            let label = $("<label>");
            label.addClass("expando closed");
            label.text(`${item.Label || item.id}`);
            $rule.append(label);
        }

        let icons = this.renderIcons(item);

        let $icons = $("<div>").addClass("icons").appendTo($rule);
        icons.forEach((icon, i) => {
            let $item = $("<div>").addClass("icon symbology-icon").appendTo($icons);
            $item.append(icon);

            let iconData = item.Icons[i];
            if (iconData.Label) {
                let label = $("<label>").text(iconData.Label);
                $item.append(label);
            }
        });

        return $rule[0].outerHTML;
    }

    renderItems(data: { items: Array<Portal.MonikerSymbologyElement> }) {
        return data.items.map(item => this.renderItem(item));
    }
}

let template = new SymbologyTemplate();

export = (data: {
    items: Array<Portal.MonikerSymbologyElement>
}) => template.renderItems(data);
